import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './contexts/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import AcceptInvite from './pages/AcceptInvite';
import Dashboard from './pages/Dashboard';
import ClientsList from './pages/clients/ClientsList';
import ClientDetail from './pages/clients/ClientDetail';
import ProposalsList from './pages/proposals/ProposalsList';
import ProposalDetail from './pages/proposals/ProposalDetail';
import ContractsList from './pages/contracts/ContractsList';
import ContractDetail from './pages/contracts/ContractDetail';
import InvoicesList from './pages/invoices/InvoicesList';
import InvoiceDetail from './pages/invoices/InvoiceDetail';
import RecurringList from './pages/recurring/RecurringList';
import RecurringDetail from './pages/recurring/RecurringDetail';
import Renewals from './pages/Renewals';
import DocumentsGlobal from './pages/Documents';
import PublicProposal from './pages/PublicProposal';
import PublicProposalNarrative from './pages/PublicProposalNarrative';
import PublicTerms from './pages/PublicTerms';
import Modules from './pages/Modules';
import SettingsLayout from './pages/settings/SettingsLayout';
import CompanySettings from './pages/settings/CompanySettings';
import UsersSettings from './pages/settings/UsersSettings';
import IntegrationsSettings from './pages/settings/IntegrationsSettings';
import TermsSettings from './pages/settings/TermsSettings';
import AuditLogSettings from './pages/settings/AuditLogSettings';
import RemindersSettings from './pages/settings/RemindersSettings';
import ProfitabilitySettings from './pages/settings/ProfitabilitySettings';
import Reports from './pages/Reports';
import Profitability from './pages/profitability/Profitability';
import MonzoTransactions from './pages/MonzoTransactions';
import Bookkeeping from './pages/Bookkeeping';
import GeneralLedger from './pages/GeneralLedger';
import Projects from './pages/Projects';
import GoCardlessComplete from './pages/GoCardlessComplete';
import LeadDiscovery from './pages/leadgen/LeadDiscovery';
import LeadsDatabase from './pages/leadgen/LeadsDatabase';
import LeadPipeline from './pages/leadgen/Pipeline';
import ImportProspects from './pages/leadgen/ImportProspects';
import EmailCampaigns from './pages/leadgen/EmailCampaigns';
import EmailCampaignBuilder from './pages/leadgen/EmailCampaignBuilder';
import EmailCampaignDetail from './pages/leadgen/EmailCampaignDetail';
import LeadGenInbox from './pages/leadgen/LeadGenInbox';
import BacklogBoard from './pages/backlog/BacklogBoard';
import NDAsList from './pages/ndas/NDAsList';
import NDADetail from './pages/ndas/NDADetail';
import PublicNDA from './pages/PublicNDA';
import NDATemplateSettings from './pages/settings/NDATemplateSettings';
import SupportHubBoard from './pages/support/SupportHubBoard';
import SupportInbox from './pages/support/SupportInbox';
import SupportDashboard from './pages/support/SupportDashboard';
import SupportTicketForm from './pages/support/SupportTicketForm';
import GeneralTicketForm from './pages/support/GeneralTicketForm';
import PublicTicketView from './pages/support/PublicTicketView';
import MyRequests from './pages/support/MyRequests';
import RequirePerm from './components/RequirePerm';
import './App.css';

export default function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" richColors closeButton />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/accept-invite" element={<AcceptInvite />} />
                    <Route path="/p/:token" element={<PublicProposal />} />
                    <Route path="/p/:token/narrative" element={<PublicProposalNarrative />} />
                    <Route path="/p/:token/terms" element={<PublicTerms />} />
                    <Route path="/n/:token" element={<PublicNDA />} />
                    <Route path="/ticket/support" element={<GeneralTicketForm />} />
                    <Route path="/ticket/:code" element={<SupportTicketForm />} />
                    <Route path="/support/my-requests" element={<MyRequests />} />
                    <Route path="/support/my-requests/:token" element={<MyRequests />} />
                    <Route path="/support/:token" element={<PublicTicketView />} />
                    <Route path="/gocardless/complete" element={<GoCardlessComplete />} />
                    <Route element={<Layout />}>
                        <Route path="/" element={<Navigate to="/dashboard" replace />} />
                        <Route path="/dashboard" element={<RequirePerm module="dashboard"><Dashboard /></RequirePerm>} />
                        <Route path="/clients" element={<RequirePerm module="crm"><ClientsList /></RequirePerm>} />
                        <Route path="/clients/:id" element={<RequirePerm module="crm"><ClientDetail /></RequirePerm>} />
                        <Route path="/proposals" element={<RequirePerm module="proposals"><ProposalsList /></RequirePerm>} />
                        <Route path="/proposals/:id" element={<RequirePerm module="proposals"><ProposalDetail /></RequirePerm>} />
                        <Route path="/contracts" element={<RequirePerm module="proposals"><ContractsList /></RequirePerm>} />
                        <Route path="/contracts/:id" element={<RequirePerm module="proposals"><ContractDetail /></RequirePerm>} />
                        <Route path="/ndas" element={<RequirePerm module="proposals"><NDAsList /></RequirePerm>} />
                        <Route path="/ndas/:id" element={<RequirePerm module="proposals"><NDADetail /></RequirePerm>} />
                        <Route path="/renewals" element={<RequirePerm module="proposals"><Renewals /></RequirePerm>} />
                        <Route path="/invoices" element={<RequirePerm module="finance"><InvoicesList /></RequirePerm>} />
                        <Route path="/invoices/:id" element={<RequirePerm module="finance"><InvoiceDetail /></RequirePerm>} />
                        <Route path="/recurring" element={<RequirePerm module="finance"><RecurringList /></RequirePerm>} />
                        <Route path="/recurring/:id" element={<RequirePerm module="finance"><RecurringDetail /></RequirePerm>} />
                        <Route path="/modules" element={<RequirePerm module="projects"><Modules /></RequirePerm>} />
                        <Route path="/documents" element={<RequirePerm module="projects"><DocumentsGlobal /></RequirePerm>} />
                        <Route path="/reports" element={<RequirePerm module="finance"><Reports /></RequirePerm>} />
                        <Route path="/profitability" element={<RequirePerm module="finance"><Profitability /></RequirePerm>} />
                        <Route path="/monzo" element={<RequirePerm module="finance"><MonzoTransactions /></RequirePerm>} />
                        <Route path="/bookkeeping" element={<RequirePerm module="finance"><Bookkeeping /></RequirePerm>} />
                        <Route path="/ledger" element={<RequirePerm module="finance"><GeneralLedger /></RequirePerm>} />
                        <Route path="/projects" element={<RequirePerm module="projects"><Projects /></RequirePerm>} />
                        <Route path="/backlog"  element={<RequirePerm module="projects"><BacklogBoard /></RequirePerm>} />
                        <Route path="/support-hub" element={<RequirePerm module="support"><SupportInbox /></RequirePerm>} />
                        <Route path="/support-hub/board" element={<RequirePerm module="support"><SupportHubBoard /></RequirePerm>} />
                        <Route path="/support-hub/dashboard" element={<RequirePerm module="support"><SupportDashboard /></RequirePerm>} />
                        <Route path="/leadgen/discover" element={<RequirePerm module="leadgen"><LeadDiscovery /></RequirePerm>} />
                        <Route path="/leadgen/leads" element={<RequirePerm module="leadgen"><LeadsDatabase /></RequirePerm>} />
                        <Route path="/leadgen/pipeline" element={<RequirePerm module="leadgen"><LeadPipeline /></RequirePerm>} />
                        <Route path="/leadgen/import" element={<RequirePerm module="leadgen"><ImportProspects /></RequirePerm>} />
                        <Route path="/leadgen/email-campaigns" element={<RequirePerm module="leadgen"><EmailCampaigns /></RequirePerm>} />
                        <Route path="/leadgen/email-campaigns/new" element={<RequirePerm module="leadgen"><EmailCampaignBuilder /></RequirePerm>} />
                        <Route path="/leadgen/email-campaigns/:id" element={<RequirePerm module="leadgen"><EmailCampaignDetail /></RequirePerm>} />
                        <Route path="/leadgen/inbox" element={<RequirePerm module="leadgen"><LeadGenInbox /></RequirePerm>} />

                        <Route path="/settings" element={<RequirePerm module="settings"><SettingsLayout /></RequirePerm>}>
                            <Route index element={<Navigate to="/settings/company" replace />} />
                            <Route path="company" element={<CompanySettings />} />
                            <Route path="users" element={<UsersSettings />} />
                            <Route path="integrations" element={<IntegrationsSettings />} />
                            <Route path="terms" element={<TermsSettings />} />
                            <Route path="reminders" element={<RemindersSettings />} />
                            <Route path="profitability" element={<ProfitabilitySettings />} />
                            <Route path="nda-template" element={<NDATemplateSettings />} />
                            <Route path="audit-log" element={<AuditLogSettings />} />
                        </Route>
                    </Route>
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}
